module.exports = __webpack_public_path__ + "static/media/Long Long Long III_game.310a2b46.png";